import "@babel/polyfill";

class dataServices{
    constructor(){
        // this.baseAddress = '/modService/ListController/GetModItems?webUrl='; 
        this.baseAddress = '/modService/ListController/';
    }
    //http://edit.weaponsd3.mod.gov.il/mod/ListController/GetModItems?webUrl=http://edit.weaponsd3.mod.gov.il&listName=%D7%94%D7%95%D7%93%D7%A2%D7%95%D7%AA&viewName=All%20Items
//http://www.modspapi.mod.gov.il/api/ListController/GetModItems?webUrl=http://reactproject&listName=reactimages&viewName=allitems
   
getSPListItems(siteUrl,listName,viewName){

     //   const address = `${this.baseAddress}('${listName}')/Items?$select=${fileds.join(',')}`;
     listName = encodeURIComponent(listName);
     viewName = encodeURIComponent(viewName);
        const address = `${this.baseAddress}GetModItems?webUrl=${siteUrl}&listName=${listName}&viewName=${viewName}`;
        return axios.get(address);
    }

    setContactUsData(siteUrl,data)
    {
        let address =`${this.baseAddress}SetContactUs?webUrl=${siteUrl}`;
        return axios.post(address,data)  ;              
     }
     SetNewsLetter(siteUrl,data)
     {
         let address =`${this.baseAddress}SetNewsLetter?webUrl=${siteUrl}`;
         return axios.post(address,data)  ;              
      }
    //   SetNewsLetter(siteUrl)
    //   {
    //       let address =`${this.baseAddress}SetNewsLetter?webUrl=${siteUrl}`;
    //       const data = {
    //         Fields:{
    //              Title: {value: 'ניב הסחי'},
    //              MODPhoneNumber: { value: '05066654878'},
    //              MODEMail: { value: 'niv@dfdf.gmail'}
    //         }
    //      };
    //       return axios.post(address,data)  ;              
    //    }
}


export default new dataServices(); 